import { Draft } from "immer";

import { NOTIFICATION_LIMITS } from "@dashboard-v3/shared";

import { State } from "../../types";
import { isBlank } from "utils/string";
import { getActionState } from "pages/Rules/Form/context/ruleSelectors";

export default function validate(draft: Draft<State>) {
  draft.steps.action.valid = isValidByContentType(draft);
}

function isValidByContentType(draft: Draft<State>) {
  if (draft.rule.actionType === "BLOCK_ATTACHMENTS") {
    const { blockNotification } = draft.rule.blockAttachments || {};

    if (!blockNotification) return true;

    const { title, bodyText } = blockNotification;

    if (title?.length > NOTIFICATION_LIMITS.TITLE) return false;
    if (bodyText?.length > NOTIFICATION_LIMITS.BODY_TEXT) return false;

    return true;
  }

  const { actionType } = draft.rule;
  const action = getActionState(draft.rule);
  const types = action.content.map(c => c.type);

  if (!types.length) return false;

  if (
    actionType === "PROTECT_EMAILS" &&
    !(types.includes("ATTACHMENTS") && types.includes("PDF"))
  ) {
    return false;
  }

  if (actionType === "REPLACE_ATTACHMENTS" && !types.includes("ATTACHMENTS")) {
    return false;
  }

  if (actionType === "ZIP_ATTACHMENTS") {
    const {
      passwordNotificationToRecipient,
      passwordNotificationToSender,
      senderNotification,
    } = draft.rule.zipAttachments;

    if (senderNotification) {
      const { title, bodyText } = senderNotification;
      if (title?.length > NOTIFICATION_LIMITS.TITLE) return false;
      if (bodyText?.length > NOTIFICATION_LIMITS.BODY_TEXT) return false;
    }

    return isValidOptionForZipPassword(
      passwordNotificationToRecipient,
      passwordNotificationToSender
    );
  }

  if ("senderNotification" in action) {
    const { senderNotification } = action;
    const isValid = Object.values(senderNotification).every(value => {
      return !isBlank(value);
    });

    if (!isValid) return false;
  }

  if ("passwordNotificationText" in action) {
    const { passwordNotificationText } = action;
    const isValid = Object.values(passwordNotificationText).every(value => {
      return !isBlank(value);
    });

    if (!isValid) return false;

    const { subjectTag, recipientLineText, senderLineText, senderAllLineText } =
      passwordNotificationText;

    if (subjectTag?.length > NOTIFICATION_LIMITS.SUBJECT_TAG) return false;
    if (recipientLineText?.length > NOTIFICATION_LIMITS.MESSAGE) return false;
    if (senderLineText?.length > NOTIFICATION_LIMITS.MESSAGE) return false;
    if (senderAllLineText?.length > NOTIFICATION_LIMITS.MESSAGE) return false;
  }

  return true;
}

export function isValidOptionForZipPassword(
  passwordNotificationToRecipient: boolean,
  passwordNotificationToSender: boolean
) {
  return passwordNotificationToRecipient || passwordNotificationToSender;
}
